import { JwtToken } from "@sky/xerxes-client-react";
import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { CognitoIdentityProviderClient } from "@aws-sdk/client-cognito-identity-provider";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { COGNITO, DYNAMODB } from '../config';

export default class AwsService {
    protected readonly cognitoClient: CognitoIdentityProviderClient;
    protected readonly ddbClient: DynamoDBClient;

    public constructor(token: JwtToken) {
        this.cognitoClient = new CognitoIdentityProviderClient({
            region: COGNITO.region ,
            credentials: fromCognitoIdentityPool({
                identityPoolId: COGNITO.identityPoolId,
                // customRoleArn: AWS_ADMIN_ROLE,
                logins: {
                    [`cognito-idp.${COGNITO.region}.amazonaws.com/${COGNITO.userPoolId}`]: token?.getToken()!
                },
                clientConfig: { 
                    region: COGNITO.region,
                    maxAttempts: DYNAMODB.maxAttempts
                },
            }),
        });

        this.ddbClient = new DynamoDBClient({
            region: DYNAMODB.region,
            credentials: fromCognitoIdentityPool({
                identityPoolId: COGNITO.identityPoolId,
                // customRoleArn: AWS_ADMIN_ROLE,
                logins: {
                    [`cognito-idp.${COGNITO.region}.amazonaws.com/${COGNITO.userPoolId}`]: token?.getToken()!
                },
                clientConfig: { 
                    region: DYNAMODB.region,
                    maxAttempts: DYNAMODB.maxAttempts
                },
            }),
        });
    }

}

